import React from "react";
import "./AboutPage.css";
import About from "../components/About";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

const AboutPage = () => {
  return (
    <>
      <SEO
        title="Car Forensics LTD | About Us"
        description="Learn more about Car Forensics LTD — a family-run mobile garage and vehicle diagnostics specialist serving Kent, including Maidstone, Gillingham, Sevenoaks and Sittingbourne. Trusted service with 15+ years experience."
        canonical="https://carforensic.uk/about"
      />

      {/* Banner Section */}
      <section className="about-banner">
        <div className="overlay"></div>
        <h1 className="about-heading">ABOUT US</h1>
      </section>

      <About showButton={false} />
      <ContactSection />
      <Footer />
    </>
  );
};

export default AboutPage;
